import React from 'react';
import {
  Box,
  TableHead,
  TableRow,
  TableCell,
  IconButton
} from '@material-ui/core';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';

const TableHeader = ({ handleAnchorEl, columns, path }) => {
  return (
    <TableHead>
      <TableRow>
        {columns.map(column => (
          <TableCell
            key={column.id}
            align={column.align}
            style={{
              minWidth: column.minWidth,
              maxWidth: column.maxWidth,
              width: column.maxWidth
            }}
          >
            {column.label}
          </TableCell>
        ))}
        <TableCell
          align="right"
          style={{
            maxWidth: 120,
            width: 120
          }}
        >
          <Box display="inline-flex">
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleAnchorEl({ type: 'folder', path })}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
